<template>
    <div class='demo'>
      <div>
        <video
          ref="mylive"
          id="mylive"
          poster="https://o-yzx.bysjy.com.cn/yxdczh0000000001/mates/202009/yxz5f60671f02566.jpg"
          style="width:100%;height:200px;"
          src="https://o-yzx.bysjy.com.cn/yxdczh0000000001/mates/202009/yxz5f6055f116731.MP4"
          :autoplay="true"
          :muted ="true" 
          :playsinline="true" 
          x5-playsinline="true" 
          x5-video-player-type="h5"      
          webkit-playsinline="true"       
          preload="auto"        
          x5-video-player-fullscreen="false"              
          controls
         >
         </video>
      </div>
      <div class="page" style="padding: 20px;" >
         <van-button type="primary" block @click="bofang" >播放视频</van-button>
      </div>
      <div class="page" style="padding: 20px;" >
        <van-button type="primary" block click="bindChange('https://o-yzx.bysjy.com.cn/yxdczh0000000001/mates/202009/yxz5f6055f116731.MP4')" >切换视频源2</van-button>
    </div>
    </div>
    
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import wx from 'weixin-js-sdk'
import VConsole from "vconsole";
var vConsole = new VConsole();

export default {
        name: "wxvideo",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                bodyShow: false,
                curriculum_audio_detail: [],
                setTimeFlag: 1,
                playtimes: 0, //视频观看起点
            }
        },
        created() {
            //console.log('this.$refs.videoPlayer.player created',this.$refs.videoPlayer);
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
        },
        
        mounted() {
            // this.util.hideOptionMenu()
            this.init()
            this.$(document).attr('title','测试')
            console.log("父组件")

            
            
            // console.log('this.$refs.videoPlayer.player1',this.$refs.videoPlayer);
            // this.onPlayerPlay(this.$refs.videoPlayer.player)
            
            if (typeof WeixinJSBridge == "undefined" ||1) { //屏蔽分享按钮
                console.log("undefined")
                if (document.addEventListener ) {
                    console.log("document.addEventListener")
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if (document.attachEvent) {
                    console.log("document.attachEvent")
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
            } else {
                console.log("defined")
                this.onBridgeReady();
            }
            
            
        },
        methods:{
            init(){
                //this.getvideo()
            },
            bofang(){
              console.log("点击播放")
              const myplayer =  this.$refs.mylive
              myplayer.play()
            },
            onBridgeReady(){
               
                console.log("onBridgeReady")
                console.log("wx",wx)
                //console.log("myplayer",myplayer)
                 const myplayer =  this.$refs.mylive
                 //myplayer.play()
                
                //WeixinJSBridge.call('hideOptionMenu');
                WeixinJSBridge.invoke('getNetworkType',{},function (e){


                 //alert(e.err_msg);
                  console.log("wxcallback")
                   myplayer.play()

                });
               
               
            },
            
        }
    }

</script>
